import { supabase } from "@/integrations/supabase/client";

export type AnalyticsEvent =
  | "user_signup"
  | "quiz_started"
  | "quiz_completed"
  | "book_tbr"
  | "book_read"
  | "book_skipped"
  | "review_submitted"
  | "feedback_submitted"
  | "quiz_history_viewed"
  | "quiz_history_saved_all"
  | "quiz_history_retake_similar"
  | "quiz_reminder_sent"
  | "quiz_reminder_clicked"
  | "daily_match_viewed"
  | "daily_match_clicked"
  | "daily_match_saved"
  | "daily_match_skipped"
  | "book_dna_viewed"
  | "book_dna_shared"
  | "pwa_launched"
  | "pwa_installed"
  | "pwa_install_prompt_shown"
  | "pwa_install_choice"
  | "pwa_install_dismissed";

export const trackEvent = async (
  event_type: AnalyticsEvent,
  metadata: Record<string, unknown> = {}
) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from("analytics_events").insert({
      user_id: user?.id ?? null,
      event_type,
      metadata: metadata as never,
    });
  } catch {
    // analytics should never break UX
  }
};
